var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "app-main" },
    [
      _vm.$route.meta.keepAlive
        ? _c(
            "keep-alive",
            { attrs: { max: 10 } },
            [
              _vm.$route.meta.keepAlive
                ? _c("router-view", { key: _vm.key })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      !_vm.$route.meta.keepAlive
        ? _c("router-view", { key: _vm.key })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }